export function openModal(selector) {
    const modal = document.querySelector(selector);
    if (!modal) return;

    modal.style.display = 'block';
    modal.classList.add('show');

    let backdrop = document.createElement('div');
    backdrop.classList.add('modal-backdrop', 'fade', 'show');
    backdrop.addEventListener('mousedown', () => {
        closeModal(selector);
    });
    modal.querySelector('.modal-header .btn-close').addEventListener('click', () => {
        closeModal(selector);
    });
    document.querySelector('body').appendChild(backdrop);
    document.querySelector('body').classList.add('modal-open');
}

export function closeModal(selector) {
    const modal = document.querySelector(selector);
    if (!modal) return;

    modal.style.display = null;
    modal.classList.remove('show');

    // usuwa zdarzenia z przycisku zamknięcia
    const closeButton = modal.querySelector('.modal-header .btn-close');
    const newCloseButton = closeButton.cloneNode(true);
    closeButton.parentNode.replaceChild(newCloseButton, closeButton);

    document.querySelector('body .modal-backdrop')?.remove();
    document.querySelector('body').classList.remove('modal-open');
}